export function expirationIndexToReadable(index, withLabel = true) {
  if (!index) return 'disabled for auto recache off';
  if (index > 24) return `${index - 23}${withLabel ? ' days' : ''}`;
  return `${index}${withLabel ? ' hours' : ''}`;
}

export function daysToExpirationIndex(days) {
  // 23 ticks for hours granularity, plus one tick for each day
  if (days < 1) return days * 24;

  return 23 + days;
}
